import React from 'react';
import ReactDOM from 'react-dom';
import Loadable from 'react-loadable';

export const Nav = Loadable({
    loader: () => import(/* webpackChunkName: "Nav" */ './nav'),
    loading: () => <div />,
});
